import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@shared-components/base-component';
import { AppHelper } from '@shared-helpers/appHelper';

@Component({
  selector: 'fourd-brand-logo',
  templateUrl: './brand-logo.component.html',
  providers: [...BaseComponent.componentProviders],
})
export class BrandLogoComponent extends BaseComponent implements OnInit {    
  constructor() { super("BrandLogoComponent"); }

  ngOnInit() {

  }

  getMimeType(thumbnailFileName: string) {
    return AppHelper.getImageMimeTypeFromFilename(thumbnailFileName);
  }

}
